angular.module('bribac.components.mainMenu', [
  'bribac.translations',
  'bribac.values',
  'bribac.services.api'
])

  .component('mainMenu', {
    templateUrl: 'main-menu-component.html',
    controller: 'MainMenuComponentCtrl'
  })

  .controller('MainMenuComponentCtrl', function(
    $scope,
    $location,
    api,
    permissions,
    state,
    PERMISSION,
    ROLES,
    DOCUMENTATION
  ) {
    var $ctrl = this

    $ctrl.state = state
    $ctrl.permissions = permissions

    $ctrl.ROLES = ROLES
    $ctrl.DOCUMENTATION = DOCUMENTATION

    $ctrl.composeLink = function() {
      var link = $ctrl.DOCUMENTATION.BASE_URL
      var role = $ctrl.state.currentAgent.roles[0]
      switch(role) {
        case ROLES.SUPER_ADMIN:
          link += $ctrl.DOCUMENTATION.SUPER_ADMIN_HTML
          break;
        case ROLES.ADMIN:
          link += $ctrl.DOCUMENTATION.ADMIN_HTML
          break;
        case ROLES.GROUP_ADMIN:
          link += $ctrl.DOCUMENTATION.GROUP_ADMIN_HTML
          break;
      }
      return link
    }

    $ctrl.documentationLink = $ctrl.composeLink()

    $ctrl.menuItems = [
      {
        translation: 'home',
        href: '#!/',
        regexp: /^\/$/,
        active: false,
        icon: 'fa fa-home'
      },
      {
        translation: 'alerts',
        href: '#!/alerts',
        regexp: /^\/alerts(\/|$)/,
        active: false,
        icon: 'fa fa-warning'
      },
      {
        translation: 'add',
        href: '#!/add',
        regexp: /^\/add(\/|$)/,
        active: false,
        icon: 'fa fa-plus'
      },
      {
        translation: 'templates',
        href: '#!/templates',
        regexp: /^\/templates(\/|$)/,
        active: false,
        icon: 'fa fa-copy'
      },
      {
        translation: 'search',
        href: '#!/search',
        regexp: /^\/search(\/|$)/,
        active: false,
        icon: 'fa fa-search'
      },
      {
        translation: 'organizations',
        href: '#!/organization',
        regexp: /^\/organization(\/|$)/,
        active: false,
        icon: 'fa fa-university',
        permission: PERMISSION.MANAGE_ORGANIZATION
      },
      {
        translation: 'ibac',
        href: '#!/ibac',
        regexp: /^\/ibac(\/|$)/,
        active: false,
        icon: 'fa fa-cube',
        permission: PERMISSION.MANAGE_IBAC
      },
      {
        translation: 'myProfile',
        href: '#!/agent/me',
        regexp: /^\/agent\/me(\/|$)/,
        active: false,
        icon: 'fa fa-cog'
      },
      {
        translation: 'reports',
        href: '#!/reports',
        regexp: /^\/reports(\/|$)/,
        active: false,
        icon: 'fa fa-bullhorn'
      }
    ]

    $ctrl.logout = function() {
      api.logout()
      $location.path('/login')
    }

    $scope.$on('$locationChangeSuccess', function() {
      var path = $location.path()

      $ctrl.menuItems.forEach(function(item) {
        item.active = item.regexp.test(path)
      })
    })
  })
